export const activateProctor = (lntToken) => {

	if(!lntToken || lntToken === '') {
		window.proctorStarted = false;
		localStorage.setItem('LTproctorToken', '')
		localStorage.setItem('CallproctorToken', '')
		window.location.reload()
	}

	window.supervisor
		.init({
			provider: 'jwt',
			// get JWT string from L&T server
			token: lntToken,
		})
		.then(function () {
			// start proctoring session
			window.proctorStarted = true;
			console.log('proctor start');
			return window.supervisor.start();
		})
		.catch(function (err) {
			// show alert with an error
			console.log('proctor launch error', err);
			window.proctorStarted = false;
			localStorage.setItem('LTproctorToken', '')
			localStorage.setItem('CallproctorToken', '')
			window.location.reload()
		});
	return lntToken;
};

export const stopProctor = () => {
	if(window.proctorStarted) {
		window.proctorStarted = false;
		console.log('proctor 1 stop');
		window.supervisor.stop();
	}
};

export const checkProctorStatus = () => {
	return window.proctorStarted
}